import React, { useContext, useEffect, useRef, useState } from "react";
import styled, { css, keyframes } from "styled-components";
import { ProductContext } from "../../../context/ProductContext";
import { useNavigate } from "react-router-dom";
import debounce from "lodash.debounce";
import APIService from "../../../services/APIService";
import { useNavigation } from "../../../utils/navigation";
import { useTranslation } from "react-i18next";
import { featured_categories } from "../../../utils/global_const";
import SimpleContext from "../../../context/SimpleContext";
import { AuthUserContext } from "../../../context/AuthUserContext";

const fadeInTop = keyframes`
  from {
    clip-path: polygon(0% 0%, 100% 0%, 100% 0%, 0% 0%);
  }
  to {
    clip-path: polygon(0% 0%, 100% 0%, 100% 100%, 0% 100%);
    
  }
`;
const fadeOutBottom = keyframes`
  from {
    clip-path: polygon(0% 0%, 100% 0%, 100% 100%, 0% 100%);
  }
  to {
    clip-path: polygon(0% 0%, 100% 0%, 100% 0%, 0% 0%);
  }
`;
const InputContainer = styled.div`
  display: flex;
  //display: ${(props) => (props.$show ? "flex" : "none")};
  align-items: center;
  justify-content: center;
  margin: 0 auto;
  /* position: fixed;

  
  top: 0;
  left: 0;
  */

  max-width: 100vw;
  z-index: 2;
  height: var(--navbar-mini);
  width: 90%;

  @media (min-width: 768px) {
    //height: auto;
    width: 100%;
    height: 40px;
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
    top: auto;
    border-radius: ${(props) => (props.$isOpen ? "8px 8px 0 0 " : "8px")};
  }
  background-color: var(--bg-100);
  border-radius: 4px;
`;

const InputWrapper = styled.div`
  //position: relative;
  width: 90%;
  padding: 0 1px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  //background-color: var(--primary-200);

  @media (min-width: 768px) {
    width: 90%;
  }
`;

const Input = styled.input`
  font-size: var(--font-size-medium);
  font-weight: 400;
  padding: 0;
  width: 100%;

  padding: var(--spacing-xs);
  font-size: 14px;
  font-style: normal;
  &::placeholder {
    color: var(--text-200);
    font-weight: 400;
    line-height: 24px;
    border: none;
  }

  //background-color: var(--bg-100);
  border: none;
  background-color: var(--bg-100);
  &:focus {
    outline: none;
    background-color: var(--bg-100); /* Subtle background change */
  }
`;
const SVGSearch = styled.svg`
  width: 20px;
  height: 20px;
  flex-shrink: 0;
`;
const SVGSearchTop = styled.svg`
  width: 30px;
  height: 30px;
  flex-shrink: 0;
  cursor: pointer;
`;
const ResultContainer = styled.div`
  position: absolute;
  background-color: var(--bg-100);
  width: 100%;
  //top: calc(100% - var(--navbar-mini));
  top: ${(props) =>
    props.$isDeliveryHidden ? "100%" : "calc(100% - var(--navbar-mini))"};
  left: 0;
  border-radius: 0 0 8px 8px;

  z-index: 1;
  height: 90vh;

  @media (min-width: 768px) {
    width: 100%;
    left: 0;
    top: 100%;
    box-shadow: var(--shadow-large);
    //padding: 12px;
    height: auto;
    padding: 20px 0 40px 0;
    max-height: 75vh;
  }
  overflow-y: auto;
  max-height: 90vh;

  ${({ $isOpen }) =>
    $isOpen
      ? css`
          animation: ${fadeOutBottom} 0.2s ease-in-out both;
        `
      : css`
          animation: ${fadeInTop} 0.3s ease-in-out both;
        `}
`;
const ResultWrapper = styled.div`
  width: 100%;
  margin-bottom: 120px;
  @media (min-width: 768px) {
    margin-bottom: 0;
    display: flex;
    flex-direction: row-reverse;
    margin: 0 auto;
    width: 94%;
  }
`;
const InnerWrapperCategory = styled.div`
  @media (min-width: 768px) {
    padding: 24px 0;
  }
`;
const ResultItem = styled.div`
  padding: 4px 0px;
  display: flex;
  align-items: center;
  gap: 4px;
  font-size: var(--font-size-base);
  color: var(--text-100);
  cursor: pointer;
  width: 94%;

  overflow: hidden;
`;
const ProductResultGrid = styled.div`
  @media (min-width: 768px) {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
  }
`;
const ProductResult = styled(ResultItem)`
  cursor: pointer;

  min-height: 24px;
  justify-content: space-between;

  margin: 0 auto;
`;

const ResultTitle = styled.h4`
  font-size: var(--font-size-base);
  font-style: normal;
  line-height: normal;
  padding: 8px 14px;
  font-weight: 300;
`;
const ProductImageContainer = styled.div`
  margin-bottom: 12px 4px 12px 12px;
  height: 60px;
  width: 60px;
  @media (min-width: 768px) {
    margin: 0 0 12px 0;
    height: 100px;
    width: 100px;
  }
`;
const ProductPicture = styled.picture`
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: var(--bg-100);
  border-radius: 8px;

  margin: 0 auto;
`;
const ProductImage = styled.img`
  height: 100%;
`;
const IconDivNoDesktop = styled.div`
  display: block;
  display: flex;
  align-items: center;
  justify-content: center;
  @media (min-width: 768px) {
    display: none;
  }
`;
const MaskContainer = styled.div`
  position: fixed;
  right: 0;
  top: 0;
  z-index: 1;
  min-width: 100%;
  height: 100vh;
  background-color: #0000003a;
  display: none;
  @media (min-width: 768px) {
    display: ${(props) => (props.$isOpen ? "block" : "none")};
  }
`;
const MaskMobile = styled.div`
  position: fixed;
  right: 0;
  top: 0;
  z-index: 1;
  min-width: 100%;
  height: 100vh;
  background-color: var(--bg-200);
  display: block;
  @media (min-width: 768px) {
    display: none;
  }
`;
const FlexDiv = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 4px;
`;
const FlexDivProduct = styled(FlexDiv)`
  @media (min-width: 768px) {
    flex-direction: column;
    background-color: var(--bg-100);
    height: 100%;
    border-radius: 8px;
  }
  box-shadow: var(--shadow-medium);
  width: 100%;
  border: 1px solid var(--bg-300);
  @media (max-width: 768px) {
    min-height: 80px;
    max-height: 80px;
  }
`;
const CancelText = styled.span`
  color: var(--text-100);
  font-size: var(--font-size-small);
  text-decoration: underline;
  font-weight: bold;
  cursor: pointer;
  @media (min-width: 768px) {
    display: none;
  }
`;

const SVGContainer = styled.div`
  display: none;
  @media (min-width: 768px) {
    display: flex;
  }
  position: relative;
  align-self: flex-end;
  background-color: var(--bg-100);
  border-radius: 50%;
  padding: 4px;
  border: 1px solid var(--bg-100);
  margin: -40px 24px 0 0;
  align-items: center;
  z-index: 10;
  transition: all 0.3s ease;
  width: 24px;
  &:hover {
    border: 1px solid var(--text-100);
    & > span {
      opacity: 1;
      visibility: visible;
      transform: translateY(0);
    }
  }
`;
const SaveForLaterSVG = styled.svg`
  cursor: pointer;
`;
const TooltipText = styled.span`
  position: absolute;
  bottom: 110%; /* Position above the icon */
  right: 0%;

  background-color: var(--text-200);
  color: var(--bg-100);
  padding: 6px 10px;
  border-radius: 4px;
  font-size: var(--font-size-small);
  white-space: nowrap;
  opacity: 0;
  visibility: hidden;
  transition: all 0.5s ease;
  z-index: 20;

  /* Optional arrow styling for the tooltip */
  &::after {
    content: "";
    position: absolute;
    top: 100%;
    right: 10%;
    transform: translateX(-50%);
    border-width: 6px;
    border-style: solid;
    border-color: var(--text-200) transparent transparent transparent;
  }
`;
const ButtonWrapper = styled.div`
  width: 100%;
  position: fixed;
  bottom: 10px;
  left: 0;

  @media (min-width: 768px) {
    display: block;
    position: relative;
    bottom: 0;
  }
`;
const ViewAllButton = styled.button`
  width: 94%;
  color: var(--text-100);
  background-color: var(--bg-100);
  border-color: var(--bg-300);
  margin: 0 auto;
  margin-top: 14px;
  border-radius: 4px;
  padding: 14px 2px;

  &:hover {
    color: var(--text-100);
    background-color: var(--bg-100);
    border-color: var(--text-300);
  }
`;
const ProductTitleWrapper = styled.div`
  display: flex;
  align-items: flex-start; /* Dot ostaje gore kad je više redova */
  justify-content: flex-start;
  @media (min-width: 768px) {
    justify-content: center;
  }
  gap: 8px;
  width: 90%;
`;

const StatusDot = styled.span`
  flex-shrink: 0; /* Tačkica nikad ne raste */
  width: 14px;
  height: 14px;
  border-radius: 50%;
  margin-top: 4px; /* malo centriranje prema tekstu */
  background-color: ${({ $state }) =>
    $state === "in_stock"
      ? "var(--success-color)"
      : $state === "on_request"
      ? "orange"
      : "var(--error-color)"};
`;

const ProductTitle = styled.h5`
  margin: 0;
  padding: 0;
  font-weight: bold;
  word-break: break-word; /* Ako treba da prelama lepo */
`;

const HeaderInput = () => {
  const { t } = useTranslation();
  const { authTokens } = useContext(AuthUserContext);
  const { showLoginPopup } = useContext(SimpleContext);
  const { setSearchedProducts, currencyTag } = useContext(ProductContext);
  const navigate = useNavigate();
  const { goToSearch, goToProduct, goToCategory } = useNavigation();
  const [searchValue, setSearchValue] = useState("");
  const [searchProducts, setSearchProducts] = useState([]);
  const [searchProductsCount, setSearchProductsCount] = useState(null);
  const [searchCategories, setSearchCategories] = useState([]);
  const [isOpen, setIsOpen] = useState(false);
  const containerRef = useRef(null);
  const [show, setShow] = useState(false);

  // Debounce funkcija za pretragu kako bi se izbeglo preterano slanje zahteva
  const debouncedSearch = useRef(
    debounce(async (searchTerm) => {
      // Ovde dodajte logiku za slanje zahteva za pretragu
      console.log("Pretraga za:", searchTerm);
      try {
        const searchData = await APIService.SearchProducts(searchTerm);
        //console.log("searchData", searchData);
        setSearchProducts(searchData.results.products);
        setSearchProductsCount(searchData.count);
        setSearchCategories(searchData.results.brands);
      } catch (error) {
        console.error("Greška pri pretrazi:", error);
      }
    }, 300)
  ).current;

  useEffect(() => {
    if (searchValue && searchValue != "") {
      debouncedSearch(searchValue);
      setIsOpen(true);
    } else {
      setSearchProducts([]);
      setSearchCategories([]);
    }
  }, [searchValue, debouncedSearch]);

  const handleShowAll = (searchValue) => {
    setSearchedProducts(searchProducts);
    navigate(goToSearch(searchValue));
    setSearchProducts([]);
  };

  const [maxProductsToShow, setMaxProductsToShow] = useState(12);
  useEffect(() => {
    const updateProductDisplay = () => {
      if (window.innerWidth >= 1024) {
        setMaxProductsToShow(9); // Desktop
      } else if (window.innerWidth >= 768) {
        setMaxProductsToShow(9); // Tablet
      } else {
        setMaxProductsToShow(20); // Mobilni
      }
    };

    updateProductDisplay();

    window.addEventListener("resize", updateProductDisplay);

    return () => window.removeEventListener("resize", updateProductDisplay);
  }, []);

  const handleProductCardClick = (category_name, name) => {
    navigate(goToProduct(category_name, name));
    setIsOpen(false);
  };
  const handleCategoryCardClick = (name) => {
    navigate(goToCategory(name));
    setIsOpen(false);
    setShow(false);
  };
  const isDeliveryHidden = sessionStorage.getItem("headerDeliveryHidden");
  // const [isOpenBox, setIsOpenBox] = useState(false);
  // const [isOpenContainer, setIsOpenContainer] = useState(false);
  // const [isBoxAnimating, setIsBoxAnimating] = useState(false);

  // const toggleBox = () => {
  //   if (isBoxAnimating) {
  //     return;
  //   }

  //   setIsOpenBox((prev) => !prev);
  //   setIsBoxAnimating(true);

  //   setTimeout(
  //     () => {
  //       setIsOpenContainer((prev) => !prev);
  //       setIsBoxAnimating(false);
  //     },
  //     isOpenContainer ? 10 : 200
  //   ); // Trajanje animacije
  // };

  return (
    <>
      <InputContainer $isOpen={isOpen}>
        <InputWrapper>
          <SVGSearch
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <g clipPath="url(#clip0_335_5465)">
              <path
                d="M2.5 8.33333C2.5 9.09938 2.65088 9.85792 2.94404 10.5657C3.23719 11.2734 3.66687 11.9164 4.20854 12.4581C4.75022 12.9998 5.39328 13.4295 6.10101 13.7226C6.80875 14.0158 7.56729 14.1667 8.33333 14.1667C9.09938 14.1667 9.85792 14.0158 10.5657 13.7226C11.2734 13.4295 11.9164 12.9998 12.4581 12.4581C12.9998 11.9164 13.4295 11.2734 13.7226 10.5657C14.0158 9.85792 14.1667 9.09938 14.1667 8.33333C14.1667 7.56729 14.0158 6.80875 13.7226 6.10101C13.4295 5.39328 12.9998 4.75022 12.4581 4.20854C11.9164 3.66687 11.2734 3.23719 10.5657 2.94404C9.85792 2.65088 9.09938 2.5 8.33333 2.5C7.56729 2.5 6.80875 2.65088 6.10101 2.94404C5.39328 3.23719 4.75022 3.66687 4.20854 4.20854C3.66687 4.75022 3.23719 5.39328 2.94404 6.10101C2.65088 6.80875 2.5 7.56729 2.5 8.33333Z"
                stroke="var(--text-100)"
                strokeWidth="1"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M17.5 17.5L12.5 12.5"
                stroke="var(--text-100)"
                strokeWidth="1"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </g>
            <defs>
              <clipPath id="clip0_335_5465">
                <rect width="20" height="20" fill="white" />
              </clipPath>
            </defs>
          </SVGSearch>
          <Input
            type="search"
            placeholder={t("PLACEHOLDERS.SEARCH_PRODUCTS")}
            aria-label={t("PLACEHOLDERS.SEARCH_PRODUCTS")}
            value={searchValue}
            onChange={(e) => setSearchValue(e.target.value)}
            onSelect={() => {
              setIsOpen(true);
            }}
          />
          {isOpen && (
            <CancelText
              onClick={() => {
                setShow(!show);
                setIsOpen(false);

                setSearchProducts([]);
                setSearchCategories([]);
              }}
            >
              {t("BUTTONS.CANCEL")}
            </CancelText>
          )}

          {searchProducts.length && isOpen ? (
            <>
              <ResultContainer
                $isDeliveryHidden={isDeliveryHidden}
                ref={containerRef}
              >
                <ResultWrapper>
                  {searchCategories && searchCategories.length && (
                    <InnerWrapperCategory>
                      <ResultTitle>
                        {t("HEADER.BRANDS")}({searchCategories.length})
                      </ResultTitle>
                      {searchCategories
                        ?.slice(0, maxProductsToShow)
                        .map((item) => (
                          <ProductResult
                            key={item.id}
                            onClick={() => handleCategoryCardClick(item.name)}
                            style={{
                              textTransform: "uppercase",
                            }}
                          >
                            {item.name}
                          </ProductResult>
                        ))}
                    </InnerWrapperCategory>
                  )}
                  <div style={{ width: "100%" }}>
                    <ResultTitle>
                      {t("HEADER.PRODUCTS")}({searchProductsCount})
                    </ResultTitle>
                    <ProductResultGrid>
                      {searchProducts
                        ?.slice(0, maxProductsToShow)
                        .map((item) => (
                          <ProductResult
                            key={item.id}
                            onClick={() => handleProductCardClick(item.title)}
                          >
                            <FlexDivProduct>
                              <ProductImageContainer>
                                <ProductPicture>
                                  {item.images.length > 0 &&
                                    (() => {
                                      const primaryImage =
                                        item.images.find(
                                          (img) => img.is_primary
                                        ) || item.images[0];

                                      return (
                                        primaryImage && (
                                          <ProductImage
                                            src={primaryImage.image_url}
                                            alt={item.title}
                                            loading="lazy"
                                            srcSet={`
                                              ${primaryImage.image_url} 320w,
                                              ${primaryImage.image_url} 480w,
                                              ${primaryImage.image_url} 800w
                                            `}
                                            sizes="(max-width: 320px) 300px, (max-width: 480px) 440px, 800px"
                                          />
                                        )
                                      );
                                    })()}
                                </ProductPicture>
                              </ProductImageContainer>

                              <SVGContainer
                                onClick={(event) => {
                                  event.stopPropagation();
                                  if (authTokens) {
                                    //TODO
                                  } else {
                                    showLoginPopup();
                                  }
                                }}
                              >
                                <SaveForLaterSVG
                                  width="24px"
                                  height="24px"
                                  viewBox="0 0 24 24"
                                  fill="none"
                                  xmlns="http://www.w3.org/2000/svg"
                                >
                                  <path
                                    fill-rule="evenodd"
                                    clip-rule="evenodd"
                                    d="M6.75 6L7.5 5.25H16.5L17.25 6V19.3162L12 16.2051L6.75 19.3162V6ZM8.25 6.75V16.6838L12 14.4615L15.75 16.6838V6.75H8.25Z"
                                    fill="var(--text-200)"
                                  />
                                </SaveForLaterSVG>
                                <TooltipText>
                                  {t("BUTTONS.SAVE_FOR_LATER")}
                                </TooltipText>
                              </SVGContainer>

                              <ProductTitleWrapper>
                                <StatusDot $state={item.state} />
                                <ProductTitle>{item.title}</ProductTitle>
                              </ProductTitleWrapper>
                            </FlexDivProduct>
                          </ProductResult>
                        ))}
                    </ProductResultGrid>
                  </div>
                </ResultWrapper>
                <ButtonWrapper>
                  <ViewAllButton>{t("HEADER.VIEW_ALL_RESULTS")}</ViewAllButton>
                </ButtonWrapper>
              </ResultContainer>
            </>
          ) : (
            <>
              {isOpen && (
                <ResultContainer
                  $isDeliveryHidden={isDeliveryHidden}
                  ref={containerRef}
                >
                  <div>
                    <ResultTitle>{t("HEADER.POPULAR_SEARCHES")}</ResultTitle>
                    <FlexDiv
                      style={{
                        margin: "0 auto",
                        width: "94%",
                      }}
                    >
                      {featured_categories.map((item) => (
                        <ProductResult
                          key={item.id}
                          onClick={() => handleCategoryCardClick(item.name)}
                        >
                          {item.name}
                        </ProductResult>
                      ))}
                    </FlexDiv>
                  </div>
                </ResultContainer>
              )}
            </>
          )}
        </InputWrapper>
      </InputContainer>
      <MaskContainer $isOpen={isOpen} onClick={() => setIsOpen(false)} />
      {/* {show && <MaskMobile />} */}
    </>
  );
};

export default HeaderInput;
